const TitleSection = ({ titleDetail, whiteText }) => {
  return (
    <section className='DBlock titleSec pb-6'>
      <div className='relative'>
        <h3 className='uppercase text-eventGray text-sm lg:text-base'>
          {titleDetail?.upperTitle}
        </h3>
        <h1
          className={`heading uppercase ${
            whiteText ? 'text-white' : 'text-black'
          } font-bold text-lg sm:text-2xl lg:text-3xl  xl:text-4xl`}>
          {titleDetail?.middleTitle ? (
            titleDetail?.middleTitle
          ) : (
            <div>
              <span>join</span>
              <span className='text-eventLightYellow px-2'>
                {titleDetail?.joinEventTitle.slice(5, 17)}
              </span>
              <span>{titleDetail?.joinEventTitle.slice(18)}</span>
            </div>
          )}
        </h1>
        <h3
          className={`relative uppercase flex flex-wrap float-left ${
            whiteText ? 'text-white' : 'text-eventGray'
          } text-sm lg:text-base lg:-right-20 sm:-top-3 sm:-right-16 top-0 right-0 sm:pt-0 pt-1`}>
          {titleDetail?.lowerTitle ? (
            titleDetail.lowerTitle
          ) : (
            <span className='capitalize'>{titleDetail?.ceoDesignation}</span>
          )}
        </h3>
      </div>
    </section>
  );
};

export default TitleSection;
